import { LayoutSidebarRightOffOutlined, LayoutSidebarRightOutlined } from '@vindr/icons';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
import useToggle from '@vindr/utils/hooks/useToggle';
import useWindowSize from '@vindr/utils/hooks/useWindowSize';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const acceptOpenSplit = ['/studylist', '/worklist', '/assigned'];

const ToggleSplitScreen = ({ iframe }) => {
  const { t } = useTranslation('Vindoc');
  const [iframeState, , , setToggleIframe] = iframe;
  const { pathname } = useLocation();
  const { width } = useWindowSize();

  const { toggle, value, setValue } = useToggle(iframeState?.open);

  useEffect(() => {
    setValue(iframeState?.open);
  }, [iframeState?.open, setValue]);

  const handleOpenSplitWindows = useCallback(() => {
    toggle();

    setToggleIframe('', value);
  }, [setToggleIframe, toggle, value]);

  if (
    !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]) ||
    !acceptOpenSplit.includes(pathname) ||
    width < 640
  )
    return null;

  return (
    <div
      className="hidden cursor-pointer text-4xl sm:block"
      onClick={handleOpenSplitWindows}
      title={t('Split Windows')}
    >
      {value === true ? <LayoutSidebarRightOutlined /> : <LayoutSidebarRightOffOutlined />}
    </div>
  );
};

export default ToggleSplitScreen;
